import PropTypes from "prop-types";
import React from "react";
import _ from "lodash";

const optionedFormatters = {
  USD: (opts) =>
    new Intl.NumberFormat(
      "en-US",
      _.merge(
        {
          style: "currency",
          currency: "USD"
        },
        opts
      )
    )
};
optionedFormatters.default = optionedFormatters.USD;

const defaultFormatters = {
  USD: optionedFormatters.USD()
};
defaultFormatters.default = defaultFormatters.USD;

export default function Money({
  value,
  children,
  className,
  accounting,
  ...rest
}) {
  let entity = value || children;
  if (!entity) return null;

  let ch;
  if (accounting && entity.cents < 0)
    ch = `(${formatMoney({ ...entity, cents: Math.abs(entity.cents) }, rest)})`;
  else ch = formatMoney(entity, rest);

  return <span className={className}>{ch}</span>;
}

Money.propTypes = {
  value: PropTypes.shape({
    cents: PropTypes.number,
    currency: PropTypes.string
  }),
  children: PropTypes.any,
  className: PropTypes.string,
  rounded: PropTypes.bool
};

export const formatMoney = (entity, options) => {
  let formatterOpts = null;
  if (_.get(options, "rounded")) {
    const hasCents = entity.cents % 100 > 0;
    formatterOpts = { minimumFractionDigits: hasCents ? 2 : 0 };
  }

  let formatter;
  if (!formatterOpts)
    formatter = defaultFormatters[entity.currency] || defaultFormatters.default;
  else {
    const ctor =
      optionedFormatters[entity.currency] || optionedFormatters.default;
    formatter = ctor(formatterOpts);
  }
  return formatter.format(entity.cents / 100.0);
};

function floatToMoney(f) {
  return {
    cents: f * 100,
    currency: "USD"
  };
}

function intToMoney(cents) {
  return {
    cents: cents,
    currency: "USD"
  };
}

function subtractMoney(m1, m2) {
  return {
    cents: m1.cents - m2.cents,
    currency: m2.currency
  };
}
